import { render, staticRenderFns } from "./ProgressSpinner.vue?vue&type=template&id=ba4e2bb8&scoped=true&"
import script from "./ProgressSpinner.vue?vue&type=script&lang=ts&"
export * from "./ProgressSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4e2bb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
